export default __webpack_public_path__ + "static/media/amazonpay.91174373.svg";